///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2024 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import { monthsAbbreviations } from "./types";

const getPastMonthsOption = pastMonths => {
  const today = new Date();
  let pastMonthsOption = [];

  for (let i = 1; i <= pastMonths; i++) {
    const monthIndex = today.getMonth() - i;
    const month = monthIndex < 0 ? monthIndex + 12 : monthIndex;
    const year = monthIndex < 0 ? today.getFullYear() - 1 : today.getFullYear();
    pastMonthsOption.push({
      value: i,
      label:
        monthsAbbreviations[month] + " " + year
    });
  }

  return pastMonthsOption;
};

export default getPastMonthsOption;
